import React from 'react';
import { Modal, Form, Input } from 'antd';
const { TextArea } = Input;


//export default class IngresoObservacionModal extends React.Component {
class IngresoObservacionModal extends React.Component {
    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };
    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const form = {
                    observacion: values.observacion
                };
                this.props.onSave(form, this.props.form);
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Modal
                title={this.props.title}
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                width="800px"
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label={"Observación de Cuota " + this.props.formValues.correlativo} >
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion,
                                    rules: [{
                                        required: true,
                                        message: 'Requerido',
                                        whitespace: true
                                    }]
                                })(
                                    <TextArea
                                        rows={4}
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>


                        </div>
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default Form.create()(IngresoObservacionModal)